import { useMemo } from "react";
import { useListIrrigationSets } from "@/api/orval/generated/irrigation-set";
import type { IrrigationSet } from "@/api/orval/generated/schemas/irrigationSet";

export type { IrrigationSet };

/** Shared so a pending list doesn't hand callers a fresh array and bust their memos every render. */
const NO_SETS: IrrigationSet[] = [];

/**
 * Live irrigation sets, soft-deleted ones already removed. Every caller wants that filter, and one
 * that forgot it could still resolve a deleted set by id.
 */
export function useIrrigationSets() {
    const { data, isLoading, isError } = useListIrrigationSets();

    const sets = useMemo(() => {
        if (!data?.items) {
            return NO_SETS;
        }
        return data.items.filter((set) => !set.deleted);
    }, [data?.items]);

    // `loadFailed` is only a failure with nothing cached; see the same field on useIrrigationInstances.
    return { sets, isLoading, isError, loadFailed: isError && data?.items === undefined };
}
